import {Injectable, Inject} from '@angular/core';
import {TRANSLATIONS} from './translation';

@Injectable()
export class TranslateService {
    private currentLangString: string = "en";

    public get currentLang() {
        return this.currentLangString;
    }

    constructor(@Inject(TRANSLATIONS) private translations: any) {
    }

    public use(lang: string): void {
        this.currentLangString = lang;
    }

    private translate(key: string): string {
        const translation = key;
        if (this.translations[this.currentLang] && this.translations[this.currentLang]['default'][key]) {
            return this.translations[this.currentLang]['default'][key];
        } else if ( this.translations['en']['default'][key]) {
            return this.translations['en']['default'][key];
        }
        return translation;
    }

    public instant(key: string) {
        return this.translate(key);
    }
}
